import React from 'react';
import './Terms.css';

const Terms: React.FC = () => {
  return (
    <div className="terms-page">
      <div className="terms-container">
        <h1 className="terms-title">Terms of Service</h1>
        <p className="terms-updated">Coming Soon</p>

        <div className="terms-content">
          <section className="terms-section">
            <h2>Under Construction</h2>
            <p>
              We're currently drafting our Terms of Service to ensure they're clear,
              fair, and protect both our users and content creators.
            </p>
            <p>
              In the meantime, here's what you should know:
            </p>
            <ul>
              <li>Be respectful to other users and content creators</li>
              <li>Don't upload content you don't have rights to</li>
              <li>Don't attempt to hack, spam, or abuse the platform</li>
              <li>We reserve the right to moderate content and remove violations</li>
              <li>Your use of this platform is at your own risk</li>
            </ul>
            <p>
              For questions or concerns, please contact us at{' '}
              <a href="mailto:info@thetempestradio.com">info@thetempestradio.com</a>.
            </p>
          </section>

          <section className="terms-section">
            <h2>Why This Matters</h2>
            <p>
              Terms of Service are important legal documents, and we want to get them right.
              We're working with legal counsel to create terms that are comprehensive yet
              understandable, protective yet fair.
            </p>
            <p>
              We'll update this page once our official Terms of Service are ready. Until then,
              use common sense and treat the platform and community with respect.
            </p>
          </section>

          <div className="terms-footer">
            <p className="terms-notice">
              By using Tempest Radio, you acknowledge that official Terms of Service are
              forthcoming and agree to use the platform responsibly and in good faith.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
